// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map[data-v-7f56a0be] {\n  width: 100%;\n  height: calc(100vh - 177px);\n}\n", ""]);
// Exports
module.exports = exports;
